export enum RouteNames {
    STUDENT_FORM = "Review information",
    TRANSCRIPT_UPLOAD = "Upload transcript",
    BURSARY_DETAILS = "Bursary details",
    STUDENT_DETAILS = "Student details",
    NAV_BAR = "Nav bar",
    HOD_APPLICATIONS = "HOD Applications"
}